<mat-sidenav-container fullscreen>

  <mat-sidenav #sidenav mode="over" class="sidenav">
    <div class="profile_container">
        <span> MENU </span>
    </div>
   
  <mat-nav-list>
      <mat-list-item  *ngFor="let menu_item of menu_item_list.all()" (click)="goThere(menu_item.link)">
        <i class="material-icons"> {{ menu_item.icon }} </i>&nbsp;
        <a routerLinkActive="active"> {{ 'menu.'+menu_item.reference_name | translate}} </a>
      </mat-list-item>

      <mat-list-item>
	  <i class="material-icons"> help_outline </i>&nbsp;
	  <a href="/loggit/STATIC/web/static/doc/index.html" target="_blank"> {{ 'menu.help' | translate }} </a>
      </mat-list-item>
      
  </mat-nav-list>

  </mat-sidenav>
  
  <mat-sidenav-content>

  <app-header ></app-header>

  <div id="main_container">
    <router-outlet></router-outlet>
  </div>

  </mat-sidenav-content>


</mat-sidenav-container>
